import React from "react";
import { bool, func } from "prop-types";
import { useTranslation } from "@lib/i18n";

import Typography from "@components/shared/Typography";
import Modal from "@components/shared/Modal";

const DiscountDetailsModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      withCloseIcon
      ariaLabel={t("price.modalDiscountDetails.heading")}
      onClose={onClose}
    >
      <div className="flex flex-col gap-4 pr-4">
        <Typography className="text-primaryDark text-xl font-semibold uppercase">
          {t("price.modalDiscountDetails.heading")}
        </Typography>
        <Typography className="text-sm">
          {t("price.modalDiscountDetails.mainInfo")}
        </Typography>
      </div>
    </Modal>
  );
};

DiscountDetailsModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default DiscountDetailsModal;
